import {
  all,
  call,
  delay,
  fork,
  put,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import { toastError, toastSuccess } from 'src/common/helpers/Notifications';
import TextConstants from 'src/common/helpers/TextConstants';
import {
  HEALTH_MONITOR_ACTION,
  getHealthMonitorSettingsError,
  getHealthMonitorSettingsSuccess,
  updateHealthMonitorSettingCleanState,
  updateHealthMonitorSettingError,
  updateHealthMonitorSettingSuccess,
} from './actions';

function* getHealthMonitorSettingsSaga() {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.HEALTH_MONITOR}`;
    const apiRes = yield call(requests.getRequest, url, {});

    // GET returns a bare array of settings items
    const settings = Array.isArray(apiRes) ? apiRes : apiRes?.data || [];

    yield put(getHealthMonitorSettingsSuccess(settings));
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(getHealthMonitorSettingsError(e));
  }
}

function* updateHealthMonitorSettingSaga({ payload }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.HEALTH_MONITOR}`;
    yield call(requests.putRequest, url, payload, true);

    // Echo the confirmed payload so the reducer can update the row in place
    yield put(updateHealthMonitorSettingSuccess(payload));

    toastSuccess(
      TextConstants.Common.EditedSuccessMessage.replace(
        '{item}',
        TextConstants.HealthMonitor.Setting
      )
    );
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(updateHealthMonitorSettingError(e));
  } finally {
    yield delay(500);
    yield put(updateHealthMonitorSettingCleanState());
  }
}

export function* HealthMonitorSettingsSaga() {
  yield takeLatest(
    HEALTH_MONITOR_ACTION.GET_HEALTH_MONITOR_SETTINGS,
    getHealthMonitorSettingsSaga
  );
  // takeEvery, NOT takeLatest: each update targets an independent row
  // (entityType|entityId). takeLatest would cancel an in-flight PUT when a
  // second row is toggled — the server still persists the first change but
  // its SUCCESS action never merges, leaving the grid silently stale and
  // letting a follow-on save write the stale flag back to the backend.
  yield takeEvery(
    HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING,
    updateHealthMonitorSettingSaga
  );
}

export default function* rootSaga() {
  yield all([fork(HealthMonitorSettingsSaga)]);
}
